import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Form } from 'react-bootstrap';

export interface Props {
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const SearchInput: FC<Props> = ({ onChange, className, value }: Props) => {
  const intl = useIntl();

  return (
    <div className={(className || '') + ' d-flex search-input'}>
      <span className="mdi mdi-magnify"></span>
      <Form.Control
        data-testid="searchinput-test"
        onChange={onChange}
        placeholder={intl.formatMessage({ id: 'searchInput.placeholder' })}
        value={value}
      />
    </div>
  );
};

export default SearchInput;
